<template>
  <div class="flex-column" v-loading="loading">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <base-search :searchList="$jcpzXmglSearch" :listQuery='listQuery' v-on:search='handleFilter' v-on:btn-event="onBtnClicked" style="display: inline-block;"></base-search>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <el-row style="height: 100%;" :gutter="8" >
        <!-- <el-col :span="4" style="height: 100%;">
          <el-card shadow="never" class="body-small" style="height: 100%;overflow:auto;">
            <basic-tree :Treedata="orgsTree" :isShowCheck="true" @handleNodeClick="handleNodeClick" @getCheckedKeys="getCheckedKeys"></basic-tree >
          </el-card>
        </el-col> -->
        <el-col :span="24" style="height: 100%;">
          <div class="bg-white" style="height: 100%;" id="table_box_height">
            <basic-table :tableHeight="tableHeight" :tableHeaderList="firstHeaderList" :tableData="tableData" :listQuery="listQuery" @pagination="handleCurrentChange" @tableRowClick="tableRowClick" :tableTotal="tableTotal"></basic-table >
          </div>
        </el-col>
      </el-row>
    </div>


    <!-- 添加弹窗 -->
    <general-form :FormDialog="FormDialog" :FormList="FormList" :title="addTitle" :FormData="addform"  @cancelDialog="cancelDialog" @confirmDialog="confirmDialog"></general-form>

    <!-- 编辑弹窗 -->
    <general-form :FormDialog="FormDialogEdit" :FormList="FormList" :title="EditTitle" :FormData="modifyForm" @cancelDialog="cancelDialogEdit" @confirmDialog="confirmDialogEdit"></general-form>

  </div>

</template>

<script>
  import generalForm from '@/components/generalForm'//通用添加弹窗组件
  import * as basicDataApi from '@/api/basicDataApi/basicDataApi'//基础资料接口

  
  import {listToTreeSelect} from '@/utils'
  import * as login from '@/api/login'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import waves from '@/directive/waves' // 水波纹指令
  import Sticky from '@/components/Sticky'
  import elDragDialog from '@/directive/el-dragDialog'
  export default {
    name: 'hdybqygl',
    components: {
      Sticky,
      generalForm
    },
    directives: {
      waves,
      elDragDialog
    },
    data() {
      return {
        loading:false,//遮罩
        jsonData:[//table数据
          {areaId:'10001',areaName:'李沧区',geographicalPosition:'青山路128号',detailedAddress:'',isMountDevice:'是',isMountMap:'否',surfaceMountNum:'2',fatherNode:'',project:'青山路项目',projectCode:'300012',areaPersonNum:'000078',jurisdictionUser:'张三',}
        ],
        listQuery: { // 查询条件
          page: 1,
          limit: 50,
          key: undefined
        },
        orgs: [], // 用户可访问到的组织列表
        orgsTree: [], // 用户可访问到的所有机构组成的树
        tableData:[],
        tableHeight:500,//表格高度
        CheckedKey:[],//选中数据的id集合
        tableChooseRow:{},//table选中数据
        FormDialog:false,//添加弹窗
        addform:{},//添加表单
        modifyForm:{},//编辑表单
        FormList:{//表格列
          column:[
            {columnKey:'projectCode',columnDescription:'项目编码',columnType:'text',prop:'projectCode',width:'120',placeholder:"项目编码",},
            {columnKey:'projectName',columnDescription:'项目名称',columnType:'text',prop:'projectName',width:'120',placeholder:"项目名称",},
            // {columnKey:'superiorProject',columnDescription:'上级项目',columnType:'text',prop:'superiorProject',width:'120',placeholder:"上级项目",},
            {columnKey:'companyName',columnDescription:'公司名称',columnType:'text',prop:'companyName',width:'120',placeholder:"公司名称",},
            {columnKey:'companyAddress',columnDescription:'详细地址',columnType:'text',prop:'companyAddress',width:'120',placeholder:"详细地址",},
            {columnKey:'contact',columnDescription:'联系人',columnType:'text',prop:'contact',width:'120',placeholder:"联系人",},
            {columnKey:'contactType',columnDescription:'联系方式',columnType:'text',prop:'contactType',width:'120',placeholder:"联系方式",},
            {columnKey:'rechargePrintTimes',columnDescription:'充值打印次数',columnType:'text',prop:'rechargePrintTimes',width:'120',placeholder:"充值打印次数",},
            // {
            //   columnKey:'waterSupplyType',
            //   columnDescription:'水司类型',
            //   columnType:'select',
            //   placeholder:"请选择水司类型",
            //   prop:'waterSupplyType',
            //   width:'120',
            //   seleceOption:[
            //     {label:'类型1',value:'0'},
            //     {label:'类型2',value:'1'},
            //   ]
            // },
          ],
          //校验
          rule:{
            projectName: [{ required: true, message: "项目名称不能为空", trigger: "blur" }, ],
          }
        },
        addTitle:'添加',//添加弹窗标题
        FormDialogEdit:false,//编辑表弹窗
        EditTitle:'编辑',//添加弹窗标题
        firstHeaderList:[],// 主列表列定义
        tableTotal:0,//明细条数
      }
    },
    watch: {

    },
    computed: {
      
    },
    filters: {
      
    },
    created() {
      this.getList()
    },
    mounted() {
      this.getOrgTree()
      // 计算table高度
      this.$nextTick(()=>{
        let ele=document.getElementById("table_box_height");
        this.tableHeight=ele.offsetHeight-50
        window.addEventListener('resize', () => { 
          let ele=document.getElementById("table_box_height");
          this.tableHeight=ele.offsetHeight-50
          this.$forceUpdate()
        });
        // 计算table高度
      })
    },
    methods: {
      // 节点点击
      handleNodeClick(data) {
        console.log(data)
      },
      // 添加节点选中数据
      getCheckedKeys(data){
        console.log(data)
        this.CheckedKey = data
        var s = this.CheckedKey.length
        this.tableData = this.$store.state.tableDataSearch.slice(0,s)
      },
      // 按钮点击
      onBtnClicked: function(domId) {
        console.log('you click:' + domId)
        switch (domId) {
          case 'btnDel'://删除
            if(this.tableChooseRow.id){
              this.handleDelete(this.tableChooseRow)
            }else{
              this.$message({
                message: `请选择一条数据进行修改！`,
                type: 'error'
              })
            }
            break
          case 'btnAdd'://添加
            this.FormDialog = true
            break
          case 'btnEdit'://编辑
            if(this.tableChooseRow.id){
              this.modify(this.tableChooseRow)
            }else{
              this.$message({
                message: `请选择一条数据进行修改！`,
                type: 'error'
              })
            }
            break
          default:
            break
        }
      },
      // 获取数据
      getList() {
        this.loading = true
        basicDataApi.xmglGetList(this.listQuery).then(response => {
          if(response.code == 200){
            response.columnHeaders.forEach((item) => { // 首字母小写
              item.key = item.key.substring(0, 1).toLowerCase() + item.key.substring(1)
            })
            this.firstHeaderList = response.columnHeaders.filter(u => u.browsable && u.isList)
            this.tableData = response.data
            this.tableTotal = response.count
            this.$basicFun.getAllList()//获取全部区域
            this.loading = false
          }else{
            this.firstHeaderList = []
            this.tableData = []
            this.$notify({
              message: response.message,
              type: 'warning',
              duration: 2000
            });
            this.loading = false
          }
        }).catch(()=>{
          this.firstHeaderList = []
          this.tableData = []
          this.loading = false
        })

        // this.tableData = this.$store.state.tableDataSearch
      },
      // 获取树形组件数据
      getOrgTree() {
        var _this = this // 记录vuecomponent
        login.getOrgs().then(response => {
          _this.orgs = response.result.map(function(item) {
            return {
              id: item.id,
              label: item.name,
              parentId: item.parentId || null
            }
          })
          var orgstmp = JSON.parse(JSON.stringify(_this.orgs))
          _this.orgsTree = listToTreeSelect(orgstmp)
        })
      },
      // 搜索
      handleFilter() {
        this.listQuery.page = 1
        this.getList()
      },
      // 切换分页
      handleCurrentChange(val) {
        this.tableChooseRow = {}//重置选中项
        this.listQuery.page = val.page
        this.listQuery.limit = val.limit
        this.getList()
      },
      // 行点击
      tableRowClick(row){
        this.tableChooseRow = row
      },
      // 多行删除
      handleDelete(row) {
        this.$confirm(`确定要删除序号为${row.serialNumber}的记录吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'message-style',
          type: 'warning'
        }).then(() => {
          var data = [row.id]
          basicDataApi.xmglDelete(data).then(response => {
            if(response.code == 200){
              this.$notify({
                message: response.message,
                type: 'success',
                duration: 2000
              });
              this.getList()
              this.reset()//重置
            }else{
              this.$notify({
                message: response.message,
                type: 'warning',
                duration: 2000
              });
            }
          })
        }).catch(() => {});
      },
      // add弹窗取消
      cancelDialog(val){
        this.FormDialog = val
      },
      // add弹窗提交
      confirmDialog(){
        basicDataApi.xmglAdd(this.addform).then(response => {
          if(response.code == 200){
            this.$notify({
              message: response.message,
              type: 'success',
              duration: 2000
            });
            this.FormDialog = false
            this.getList()
          }else{
            this.$notify({
              message: response.message,
              type: 'warning',
              duration: 2000
            });
          }
        }).catch(()=>{
          this.FormDialog = false
        })
        this.reset()//重置
      },
      //重置
      reset(){
        this.addform = this.modifyForm ={
          projectCode:'',
          projectName:'',
          superiorProject:'',
          companyName:'',
          companyAddress:'',
          contact:'',
          contactType:'',
          rechargePrintTimes:'',
          displayConfigure:'',
          waterSupplyType:'',
        }
        this.tableChooseRow = {}
      },
      // 编辑表
      modify(row){
        this.modifyForm = JSON.parse(JSON.stringify(row))
        this.FormDialogEdit = true
      },
      // 编辑取消
      cancelDialogEdit(val){
        this.FormDialogEdit = val
      },
      // 编辑提交
      confirmDialogEdit(){
        basicDataApi.xmglModify(this.modifyForm).then(response => {
          if(response.code == 200){
            this.$notify({
              message: response.message,
              type: 'success',
              duration: 2000
            });
            this.FormDialogEdit = false
            this.getList()
            this.reset()//重置
          }else{
            this.$notify({
              message: response.message,
              type: 'warning',
              duration: 2000
            });
          }
        }).catch(()=>{
          this.FormDialogEdit = false
        })
      },
    },
  }

</script>

<style lang="scss" scoped>
  
</style>
